import {request} from '../../lib/api.js'
export const artworkCreatedApi={
  list:opts=>request('/api/artwork-created',opts),
  championships:(ids,opts)=>request('/api/artwork-created/championships',{...opts,query:{ids:ids.join(',')}}),
  championship:(id,opts)=>request(`/api/artwork-created/championships/${encodeURIComponent(id)}`,opts),
  revision:(id,body)=>request(`/api/artwork-created/jobs/${encodeURIComponent(id)}/revisions`,{method:'POST',body}),
}
